var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.489,
    height: 224.488,
    viewBox: "0 0 224.489 224.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agriculture",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M358.449,179.224a11.224,11.224,0,1,0-11.224,11.224A11.224,11.224,0,0,0,358.449,179.224Zm-14.966,0a3.741,3.741,0,1,1,3.741,3.741A3.741,3.741,0,0,1,343.483,179.224Z",
    transform: "translate(-170.341 -80.912)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 7.497,
    height: 11.246,
    transform: "translate(109.717 72.23)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 7.497,
    height: 11.246,
    transform: "translate(124.712 72.23)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M237.731,94.7,198.867,84.1a26.19,26.19,0,0,0-31.4-10.236l2.692,6.983a18.732,18.732,0,1,1-5.643,3.428l-4.951-5.612a26.211,26.211,0,0,0-8.869,19.646H143.21V92.833A28.194,28.194,0,0,1,171.4,64.639h24.187V57.156H180.625V27.224a3.741,3.741,0,0,0-3.741-3.741H135.727a3.741,3.741,0,0,0-3.63,2.834l-6.774,27.1H105.8V49.673h3.741a3.741,3.741,0,0,0,3.741-3.741V30.966a3.741,3.741,0,0,0-3.741-3.741H105.8V23.483h7.483V16H102.054a3.741,3.741,0,0,0-3.741,3.741v7.483H94.571a3.741,3.741,0,0,0-3.741,3.741V45.932a3.741,3.741,0,0,0,3.741,3.741h3.741v3.741h-4.17A14.554,14.554,0,0,0,79.605,67.952V86.8l-1.389.556a3.741,3.741,0,0,0-2.352,3.474v11.224a3.741,3.741,0,0,0,3.741,3.741H83.82a14.944,14.944,0,0,0,1.54,11.224h-28.2v-11.7A14.993,14.993,0,0,0,68.381,90.829V75.864A14.956,14.956,0,0,0,42.19,65.98,14.956,14.956,0,0,0,16,75.864V90.829a14.993,14.993,0,0,0,11.224,14.492v11.7H19.741V124.5H31.179L16.7,144.777l6.089,4.349L40.374,124.5h15.1L16.243,227.937l7,2.654L63.48,124.5H86L57.275,235.811l7.245,1.871L93.729,124.5h19.035L98.343,236.268l7.421.957L120.309,124.5h15.869l14.545,112.723,7.421-.957L143.724,124.5h19.035l29.208,113.18,7.245-1.871L170.487,124.5h22.52l40.241,106.088,7-2.654L201.012,124.5h15.1L233.7,149.126l6.089-4.349L225.31,124.5h11.437V117.02H195.187a26.135,26.135,0,0,0,7.309-24.17L217.343,96.9l-2.933,11.731,7.259,1.815,2.894-11.577,7.665,2.091-2.853,11.411,7.259,1.815,3.741-14.966A3.741,3.741,0,0,0,237.731,94.7Zm-139.419-60H105.8V42.19H98.312ZM151.788,105.8a26.215,26.215,0,0,0,6.791,11.224H111.267a14.944,14.944,0,0,0,1.54-11.224Zm21.354-74.829V53.415H141.018l5.933-5.933,4.837,4.837,5.291-5.291L142.114,32.062l-4.984,4.987,1.518-6.083Zm-36.136,6.57,4.654,4.654L133.9,49.948ZM87.088,75.864h7.483v4.95l-7.483,2.993Zm-3.741,17.5L99.7,86.82a3.741,3.741,0,0,0,2.352-3.474V72.122a3.741,3.741,0,0,0-3.741-3.741H87.088v-.428A7.062,7.062,0,0,1,94.143,60.9h61.339a35.719,35.719,0,0,0-19.755,31.935v5.479H108.2a14.924,14.924,0,0,0-19.766,0H83.346Zm7.483,16.174a7.483,7.483,0,1,1,7.483,7.483,7.483,7.483,0,0,1-7.483-7.483ZM53.415,68.381A7.492,7.492,0,0,1,60.9,75.864V90.829a7.483,7.483,0,0,1-3.741,6.47v-6.47H49.673V97.3a7.483,7.483,0,0,1-3.741-6.47V75.864A7.492,7.492,0,0,1,53.415,68.381ZM23.483,90.829V75.864a7.483,7.483,0,1,1,14.966,0V90.829a7.483,7.483,0,0,1-3.741,6.47v-6.47H27.224V97.3a7.483,7.483,0,0,1-3.741-6.47Zm11.224,14.492a14.983,14.983,0,0,0,7.483-4.609,14.983,14.983,0,0,0,7.483,4.609v11.7H34.707Z",
    transform: "translate(0)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M243.224,405.545A14.106,14.106,0,0,0,232,400v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541V400a14.106,14.106,0,0,0-11.224,5.545Z",
    transform: "translate(-114.98 -204.409)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M243.224,349.545A14.106,14.106,0,0,0,232,344v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541V344a14.106,14.106,0,0,0-11.224,5.545Z",
    transform: "translate(-114.98 -174.6)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M243.224,461.545A14.106,14.106,0,0,0,232,456v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541V456a14.106,14.106,0,0,0-11.224,5.545Z",
    transform: "translate(-114.98 -234.219)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M59.224,453.545A14.106,14.106,0,0,0,48,448v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541V448a14.106,14.106,0,0,0-11.224,5.545Z",
    transform: "translate(-17.034 -229.96)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M94.449,391.483V384a14.106,14.106,0,0,0-11.224,5.545A14.106,14.106,0,0,0,72,384v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541Z",
    transform: "translate(-29.81 -195.892)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M427.224,453.545A14.106,14.106,0,0,0,416,448v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541V448a14.106,14.106,0,0,0-11.224,5.545Z",
    transform: "translate(-212.926 -229.96)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M406.774,400.149l1.375-4.125a6.631,6.631,0,0,1,6.3-4.541V384a14.106,14.106,0,0,0-11.224,5.545A14.106,14.106,0,0,0,392,384v7.483a6.631,6.631,0,0,1,6.3,4.541l1.375,4.125a3.741,3.741,0,0,0,7.1,0Z",
    transform: "translate(-200.151 -195.892)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M234.343,303.634l7.483,7.483a3.741,3.741,0,0,0,5.291,0l7.483-7.483-5.291-5.291-4.837,4.838-4.837-4.838Z",
    transform: "translate(-116.227 -150.296)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M95.634,330.343l-5.291,5.291,7.483,7.483a3.742,3.742,0,0,0,5.291,0l7.483-7.483-5.291-5.291-4.837,4.838Z",
    transform: "translate(-39.574 -167.33)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M388.472,344.213a3.73,3.73,0,0,0,2.646-1.1l7.483-7.483-5.291-5.291-4.837,4.838-4.837-4.838-5.291,5.291,7.483,7.483A3.73,3.73,0,0,0,388.472,344.213Z",
    transform: "translate(-192.881 -167.33)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 7.497,
    height: 7.497,
    transform: "translate(68.481 132.209)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 7.497,
    height: 7.497,
    transform: "translate(60.984 147.204)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 7.497,
    height: 7.497,
    transform: "translate(124.712 132.209)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 7.497,
    height: 7.497,
    transform: "translate(180.942 132.209)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 7.497,
    height: 7.497,
    transform: "translate(188.439 147.204)",
    fill: "#1c6bfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/Agriculture.f8e78cf082bbdc5ec230c8b338ebdea6.svg";
export { ForwardRef as ReactComponent };